import React, {FunctionComponent} from 'react';
import {useIntl} from 'react-intl';
import {Link, useLocation, useNavigate} from 'react-router-dom';

import {RoutesUrl} from 'utils/constants/routeConstants';
import {SystemLanguage} from 'utils/constants/constants';

import Logo from 'assets/image/header/logo-2.png';
import LogoEs from 'assets/image/header/logo-2-es.png';

import './styles.scss';

export const BackNav: FunctionComponent = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  function handleBack() {
    if (location.key === 'default') {
      navigate(RoutesUrl.Home);

      return;
    }
    navigate(-1);
  }

  return <header className="back-nav">
    <Link to={RoutesUrl.Home} className="back-nav__logo" aria-label="Mira Now">
      <img src={intl.locale === SystemLanguage.Spanish ? LogoEs : Logo} alt="Mira Now, powered by Scalable Care"/>
    </Link>
    <button type="button" className="back-nav__link" onClick={handleBack}>
      {'← '}
      {intl.formatMessage({id: 'gritx.common.button.back', defaultMessage: 'Back'})}
    </button>
  </header>;
};
